<div class="rotatedevice">
  <img class="icon" src="assets/images/mobile/icn-rotatedevice-servitiqui.gif" />
  <span class="text">Please rotate the device</span>
</div>
<router-outlet></router-outlet>
